/**
 * Created by rjulius on 2/25/16.
 */
import PromptInput from "common/widgets/PromptList/PromptInput";
import PromptInputType from "common/enums/PromptInputType";
const LinePromptInput = PromptInput.extend({
    options: {
        name: "LinePromptInput",
        template: "<div></div>"
    },
    init: function(element, options) {
        PromptInput.fn.init.apply(this, arguments);

        this._updateStyle();
        this._updateSize();

        this.refresh();
    },

    canFocus: function() {
        return false;
    },

    // Do nothing - non-input type prompt has no value
    updateWidgetValue: $.noop,

    // Do nothing - non-input type prompt has no value
    value: $.noop,

    getMinSize: function() {
        var minSize = PromptInput.fn.getMinSize.apply(this, arguments);
        if (this.options.model.inputType === PromptInputType.V_LINE) {
            minSize.height = 10;
        } else {
            minSize.width = 10;
        }
        return minSize;
    },

    updateStyle: function() {
        PromptInput.fn.updateStyle.apply(this, arguments);
        this._updateStyle();
    },

    updateSize: function() {
        PromptInput.fn.updateSize.apply(this, arguments);
        this._updateSize();
    },

    _updateStyle: function() {
        var color = this.options.model.color || "000000",
            alpha = this.options.model.alpha >= 0 && this.options.model.alpha <= 1 ? this.options.model.alpha : 1;
        var style = "background-color: #" + color + "; opacity: " + alpha + "; ";
        this.input.attr("style", style);
    },

    _updateSize: function() {
        this.input.css({
            width: this.options.width + "px",
            height: this.options.height + "px"
        });
    }
});
kendo.ui.plugin(LinePromptInput);
export default LinePromptInput;
